
















import { DashboardService } from "@/services/dashboard.service";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

@Component({
  
})
export default class AssinaturasHojeCard extends Mixins(GlobalMixin) {
  totalAssinaturasHoje: number | null = null;
  loadingAssinaturas = false;

  @Prop() readonly date!: string | null;

  mounted() {
    this.onChangeDate();
  }

  @Watch("date")
  onChangeDate() {
    this.CarregarAssinaturasHoje();
  }

  async CarregarAssinaturasHoje() {
    this.loadingAssinaturas = true;
    if (this.date) {
      this.totalAssinaturasHoje = await DashboardService.AssinaturasHoje(this.date).finally(
        () => (this.loadingAssinaturas = false)
      );
    }
  }
}
